import { useEffect } from 'react';
export default function useKeypress(key, action) {
  useEffect(function () {
    var onKeyup = function onKeyup(e) {
      return e.key === key && action();
    };
    window.addEventListener('keyup', onKeyup);
    return function () {
      return window.removeEventListener('keyup', onKeyup);
    };
  }, [key, action]);
}